<template>
  <div class="menu-pdv">
    <div class="rounded border p-3 text-left mb-2 mx-1 bg-white">
      <button v-if="comanda.id_comanda || comanda.tipo_comanda === '4'" class="btn btn-third btn-sm float-right ml-2" @click="$emit('editarComanda')">
        Editar
      </button>
      <div class="h6 mb-0">
        <span class="mr-1" v-if="comanda.tipo_comanda === '1'">MESA: {{comanda.mesa}}</span>
        <span class="mr-1" v-else-if="comanda.tipo_comanda === '2'">DELIVERY</span>
        <span class="mr-1 text-ellipsis" v-else-if="comanda.tipo_comanda === '3'">COMANDA: {{comanda.ref_comanda}}</span>
        <span class="mr-1" v-else-if="comanda.tipo_comanda === '5'">BALCÃO</span>
        <span class="mr-1" v-else>Venda Rápida</span>
        <span class="badge badge-success" v-if="comanda.status === '1'">Aberta</span>
        <span class="badge badge-dark" v-if="comanda.status === '2'">Fechada</span>
        <span class="badge badge-danger" v-if="comanda.status === '3'">Cancelada</span>
      </div>
      <div class="small" v-if="comanda.id_comanda">
        <div>Venda: {{ comanda.id_contador || comanda.id_comanda }} - {{comanda.data_comanda}}</div>
      </div>
      <div class="small font-weight-bold" v-else>Nova Venda</div>
      <div class="small"><b>Atendente</b>: {{comanda.atendente || usuario.nome}}</div>
      <div class="small" v-if="comanda.id_caixa">Caixa: {{comanda.id_caixa}}</div>
      <div class="small" v-if="comanda.id_cliente && comanda.cliente">
        Cliente: {{comanda.cliente.nome_cliente}}
      </div>
      <div v-if="podeFinalizarVenda" v-show="comanda.itens.length" class="mt-2">
        <button :class="comanda.status === '1' ? 'btn-success' : 'btn-third'" class="btn btn-block py-3 text-center border border-dark" @click="$emit('finalizaVenda')">
          <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-credit-card" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <rect x="3" y="5" width="18" height="14" rx="3" />
            <line x1="3" y1="10" x2="21" y2="10" />
            <line x1="7" y1="15" x2="7.01" y2="15" />
            <line x1="11" y1="15" x2="13" y2="15" />
          </svg>
          <span class="d-block font-weight-bold small" v-if="comanda.status === '1'">Fechar Conta (Alt+9)</span>
          <span class="d-block font-weight-bold small" v-else>Pagamentos</span>
        </button>
        <button v-if="comanda.tipo_comanda === '3' && comanda.status === '1'" class="btn btn-warning btn-block" title="Importar comanda" @click="$emit('importarComanda')">
          <i class="fa fa-clone mr-1"></i> Importar Comanda
        </button>
      </div>
    </div>
    <div class="row no-gutters small text-white" v-if="comanda.tipo_comanda === '4' && comanda.itens.length && !comanda.id_comanda">
      <div class="col-6 p-1">
        <a :class="{'disabled': comanda.id_cliente}" class="btn btn-info btn-block py-3 text-left" href="javascript:" @click="addCliente(null)">
          <div class="small">
            <i class="fa fa-user-plus"></i>
            <div class="mt-1 text-nowrap">Adicionar Cliente</div>
          </div>
        </a>
      </div>
      <div class="col-6 p-1">
        <a class="btn btn-secondary py-3 btn-block text-left" href="javascript:" @click="cancelarVenda()">
          <div class="small">
            <i class="fa fa-trash-alt"></i>
            <div class="mt-1 text-nowrap">Cancelar Venda</div>
          </div>
        </a>
      </div>
      <div v-if="usuario.id_funcao === '3' || finalizarBloqueado" class="col-12 p-1">
        <button :class="comanda.status === '1' ? 'btn-success' : 'btn-third'" class="btn btn-block py-3 text-center" @click="$emit('finalizaVenda')">
          <i class="fa fa-check-circle" style="width: 24px"></i>
          <span class="d-block font-weight-bold small">Salvar Venda</span>
        </button>
      </div>
    </div>
    <div class="row no-gutters small text-white" v-else>
      <div class="col-6 p-1" v-if="menus.includes('4')">
        <a class="btn btn-third btn-block py-3 text-left" href="javascript:" @click="$emit('novaVenda')">
          <div class="small">
            <icon-sys name="fast"/>
            <div class="text-nowrap">{{menus.length === 1 ? 'Nova Venda' : 'Rápida'}} <span class="d-none d-md-inline">(Alt+1)</span></div>
          </div>
        </a>
      </div>
      <div class="col-6 p-1" v-if="menus.includes('5')">
        <a class="btn btn-info btn-block py-3 text-left" href="javascript:" @click="$emit('novaVenda', 5)">
          <div class="small">
            <icon-sys name="device"/>
            <div class="text-nowrap">Balcão (Alt+2)</div>
          </div>
        </a>
      </div>
      <div class="col-6 p-1" v-if="menus.includes('1')">
        <a href="javascript:" class="btn btn-primary btn-block py-3 text-left" @click="$emit('openModal', 1)">
          <div class="small">
            <icon-sys name="table"/>
            <div class="text-nowrap">Mesas (Alt+3)</div>
          </div>
        </a>
      </div>
      <div class="col-6 p-1" v-if="menus.includes('2')">
        <a href="javascript:" class="btn btn-success btn-block py-3 text-left" @click="$emit('novaVenda', 2)">
          <div class="small ">
            <icon-sys name="delivery"/>
            <div class="text-nowrap">Delivery (Alt+4)</div>
          </div>
        </a>
      </div>
      <div class="col-6 p-1" v-if="menus.includes('3')">
        <a class="btn btn-warning btn-block py-3 text-left" href="javascript:" @click="$emit('openModal', 3)">
          <div class="small">
            <icon-sys name="comanda"/>
            <div class="text-nowrap">Comandas (Alt+5)</div>
          </div>
        </a>
      </div>
      <div class="col-6 p-1" v-if="menus.includes('6')">
        <router-link to="/home/comissao" class="btn btn-secondary btn-block py-3 text-left">
          <div class="small">
            <icon-sys name="relatorio"/>
            <div class="text-nowrap">Minhas Comissões</div>
          </div>
        </router-link>
      </div>
      <div class="p-1" :class="fullMenu ? 'col-12' : 'col-6'">
        <a href="javascript:" class="btn btn-dark btn-block py-3 text-left" @click="$emit('openPesquisar', true)">
          <div class="small">
            <icon-sys name="search"/>
            <div class="text-nowrap">Pesquisar (Alt+7)</div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import IconSys from "../../../components/pdv/IconSys";
  export default {
    name: "MenuPdv",
    components: {IconSys},
    props: ['comanda'],

    data() {
      return {
        fullMenu: false
      }
    },

    computed: {
      usuario() {
        return this.$store.state.dataUser
      },

      catalogos() {
        return this.$store.state.catalogos;
      },

      menus() {
        return this.$store.state.dataUser.acessos.menus;
      },

      podeFinalizarVenda() {
        const possuiPermissao = this.usuario.id_funcao < 3 || this.menus.includes('7');

        return possuiPermissao && !this.finalizarBloqueado;
      },

      finalizarBloqueado() {
        return this.usuario.acessos.bloquear_finalizar === '1';
      }
    },

    methods: {
      addCliente() {
        this.$emit('addCliente');
      },

      cancelarVenda() {
        this.$helpers.confirmarSenhaAdm(this, () => {
          this.$swal({
            title: '',
            text: 'Deseja cancelar esta venda?',
            buttons: ['Não','Sim'],
            dangerMode: true
          }).then((r) => {
            if (r) {
              this.$emit('cancelarVenda');
            }
          })
        });
      }
    },

    mounted() {
      const menus = this.menus.filter(m => m !== '7');
      this.fullMenu = (menus.length % 2 === 0);
    }
  }
</script>

<style scoped>
.menu-pdv .btn {
  overflow: hidden;
}

.venda-rapida {
  background-color: #1c294e;
  color: #FFFFFF;
}

</style>
